module.exports = __webpack_public_path__ + "img/usa.4d40662c.png";